export default "__VITE_ASSET__DP67VE11__"